import { useUser, useUserSettings } from "@/composables/user";
import { AccountType, type User } from "@/services/user";
import { assertUserHasSettings } from "@/services/user/settings";

export function isMyNick(nickname: string): boolean {
  try {
    const { userSettings } = useUserSettings();
    const myNickname = userSettings.value?.nickname.toLowerCase();
    return myNickname === nickname.toLowerCase();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e: unknown) {
    return false;
  }
}

export const isOurAccount = (user: User): boolean => {
  return user.type === AccountType.Common;
};

export function assertUserIsLoggedIn(user: User | undefined): asserts user is User {
  if (user === undefined) {
    throw new Error("User is not logged in.");
  }
}

export const isVerifiedAccount = (): boolean => {
  const { userBankInfo, userSettings, userAddress } = useUserSettings();
  const { isUserLoggedIn, user } = useUser();

  if (!isUserLoggedIn.value) {
    return false;
  }

  assertUserIsLoggedIn(user.value);
  assertUserHasSettings(userSettings.value);

  const isBankAccountVerified = userBankInfo.value !== undefined && (userBankInfo.value.accountNumber !== "" || userBankInfo.value.iban !== "");

  return (
    isBankAccountVerified && //
    userAddress.value !== undefined &&
    user.value.isEmailVerified === true &&
    userSettings.value.publicPhone !== "" &&
    userSettings.value.publicFullName !== ""
  );
};
